'use client';

import { cn, getColorway } from '@/utils/styles';
import { liveUpdateAttrs } from '@/libs/contentful/utils';

import CTA from '@/components/shared/CTA/CTA';
import Media from '@/components/shared/Media/Media';
import { CardsVerticalScrollItemMobileProps } from './types';
import RichTextHeadline from '@/components/shared/RichTextHeadline/RichTextHeadline';
import RichTextList from '@/components/shared/RichTextList/RichTextList';
import { getBulletListStyle } from '@/utils/bulletListHelpers';

const MobileCardsVerticalScrollItem = ({
  sys,
  headline,
  copy,
  desktopMedia,
  mobileMedia,
  desktopAspectRatio,
  mobileAspectRatio,
  cta,
  index,
  backgroundColor,
  bulletStyle,
  sectionName,
}: CardsVerticalScrollItemMobileProps) => (
  <div
    id={sectionName}
    className={cn(
      'relative w-full overflow-hidden',
      'rounded-lg',
      'shadow-[0_-10px_20px_rgba(0,0,0,0.25)]',
      getColorway(backgroundColor),
      'sticky overflow-hidden',
      'top-(--height-nav)',
      // Anchor navigation: land with the card fully visible under the nav
      'scroll-mt-var(--height-nav)',
      // Negative margin makes next card "peek" up from below (except first card)
      index > 0 && '-mt-8',
      'p-6 pb-32',
    )}
    style={{ zIndex: 10 + index }}
    data-testid={`cards-vertical-scroll-item-${index}`}>
    <div
      data-testid="headline"
      className={cn('font-sans font-semibold text-heading-sm', 'w-full text-left pb-4')}
      {...liveUpdateAttrs(sys?.id, 'headline')}>
      <RichTextHeadline headline={headline} />
    </div>
    <div
      className={cn('font-serif text-label-serif [&_li]:my-0.5 mb-1.5')}
      {...liveUpdateAttrs(sys?.id, 'copy')}
      data-testid="card-expanded-copy">
      <RichTextList item={copy} listItemClasses="my-0" bulletListStyle={getBulletListStyle(bulletStyle)} />
    </div>
    {cta && <CTA cta={cta} variant="outline" testId="card-expanded-cta" className={cn('max-w-1/2 mt-4 mb-8')} />}
    <Media
      media={mobileMedia ?? desktopMedia}
      sizes="100vw"
      aspectRatio={mobileAspectRatio ?? desktopAspectRatio}
      className={cn('w-full rounded-lg')}
    />
  </div>
);

export default MobileCardsVerticalScrollItem;
